import { QueryEntity } from "@datorama/akita";
import { injectable } from "tsyringe";

import ReviewsImagesSliderStore, {
    ReviewsImagesSliderState,
} from "../stores/ReviewsImagesSliderStore";

@injectable()
class ReviewsImagesSliderQuery extends QueryEntity<ReviewsImagesSliderState> {
    constructor(protected store: ReviewsImagesSliderStore) {
        super(store);
    }

    active$ = this.selectActive();
    all$ = this.selectAll();
    paginationMeta$ = this.select((v) => v.paginationMeta);
    status$ = this.select((v) => v.status);
    error$ = this.selectError();
    first$ = this.selectFirst();
}

export default ReviewsImagesSliderQuery;
